import React, { useState } from 'react';
import { Button, Grid, TextField } from '@mui/material';
import { handleWarning } from '../../helpers/utils';

export const SearchProspection = ({
    generateRows = null,
    rowsState = 5,
    handleClose = null,
    setRowsState = null,
}) => {
    const [searchField, setSearchField] = useState('');

    const handleSearch = () => {
        if (searchField === '') {
            handleWarning('Hacen falta campos para poder buscar');
        } else {
            generateRows(searchField);
        }
    };

    return (
        <Grid
            container
            component="main"
            spacing={1}
            style={{
                width: '50%',
                margin: '10px 0 15px 0',
            }}
        >
            <Grid item xs={12}>
                <TextField
                    required
                    style={{ margin: '0 auto', width: '300px' }}
                    label="Buscar por:"
                    placeholder="Nuevo, Recuperado, Cautivo"
                    value={searchField}
                    onChange={({ target }) => setSearchField(target.value)}
                    onKeyDown={({ key }) => {
                        if (key === 'Enter') {
                            handleSearch();
                        }
                    }}
                />
            </Grid>

            <Grid item xs={4} style={{ display: 'flex', flexDirection: 'row' }}>
                <Button variant="text" onClick={handleSearch}>
                    Buscar
                </Button>
                <Button
                    color="error"
                    variant="text"
                    onClick={() => {
                        handleClose();
                        generateRows(null);
                        setSearchField('');
                    }}
                >
                    Cerrar
                </Button>
            </Grid>
        </Grid>
    );
};
